import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Cell } from './tableUtils';
import css from './usersTable.scss';
import Popup from '../popup/popup';
import DeleteUser from './deleteUser';
import { Mutation } from 'react-apollo';
import { UPDATE_USER } from './queries';
import AskNewPasswordBtn from '../askNewPasswordBtn/askNewPasswordBtn';

class UpdateUser extends Component {
	state = {
		...this.props,
	};
	static propTypes = {
		client_name: PropTypes.string.isRequired,
		client_address: PropTypes.string.isRequired,
		contact_firstname: PropTypes.string.isRequired,
		contact_lastname: PropTypes.string.isRequired,
		email: PropTypes.string.isRequired,
		fonction: PropTypes.string.isRequired,
		telephone: PropTypes.string.isRequired,
	};
	isModified = _ => {
		for (let key in this.state) {
			if (this.props[key] !== this.state[key]) {
				return true;
			}
		}
		return false;
	};
	updateState = e => {
		let state = {};
		state[e.target.name] = e.target.value;
		this.setState(_ => state);
	};
	render() {
		const formClass = [css.form, this.isModified() ? 'modified' : ''];
		return (
			<Mutation mutation={UPDATE_USER} variables={this.state}>
				{(updateUser, { loading, error }) => (
					<form
						className={formClass.concat(loading ? 'loading' : '').join(' ')}
						onSubmit={e => {
							e.preventDefault();
							updateUser();
						}}
					>
						<Row>
							<Cell type="deleteCol">
								<DeleteUser userId={this.props.id} />
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Nom du Client"
									name="client_name"
									onChange={this.updateState}
									value={this.state.client_name}
								/>
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Adresse du Client"
									name="client_address"
									onChange={this.updateState}
									value={this.state.client_address}
								/>
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Prenom du Contact"
									name="contact_firstname"
									onChange={this.updateState}
									value={this.state.contact_firstname}
								/>
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Nom du Contact"
									name="contact_lastname"
									onChange={this.updateState}
									value={this.state.contact_lastname}
								/>
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Fonction"
									name="fonction"
									onChange={this.updateState}
									value={this.state.fonction}
								/>
							</Cell>
							<Cell>
								<input
									type="tel"
									placeholder="Téléphone"
									name="telephone"
									onChange={this.updateState}
									value={this.state.telephone}
								/>
							</Cell>
							<Cell type="email">
								<input
									type="email"
									placeholder="Email"
									name="email"
									onChange={this.updateState}
									value={this.state.email.toLowerCase()}
								/>
							</Cell>
							<Cell>
								<AskNewPasswordBtn email={this.state.email.toLowerCase()} />
							</Cell>
							{error && (
								<Popup opened>
									{error.graphQLErrors[0]
										? error.graphQLErrors[0].message
										: 'Unknown Error'}
								</Popup>
							)}
						</Row>
						<input type="submit" hidden />
					</form>
				)}
			</Mutation>
		);
	}
}

export default UpdateUser;



// WEBPACK FOOTER //
// ./src/components/usersTable/updateUser.js